import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewActionButtons } = listModuleLenses

export default (state, { moduleId }) => viewActionButtons(moduleId, moduleDescriptions)
